// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/HybridStagePanel.tsx
import { FunctionComponent } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { InfoCallout } from '../../components/InfoCallout';
import { GroupStagesPreview } from './GroupStagesPreview';
import { KnockoutStageList } from './KnockoutStageList';

const PREFIX = 'pages.application_season.components.season_step2';

type HybridStagePanelProps = {
  isReadOnly?: boolean;
};

export const HybridStagePanel: FunctionComponent<HybridStagePanelProps> = ({
  isReadOnly = false,
}) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={6}>
      <InfoCallout icon={<ChakraFeatherIcon name="zap" boxSize="18px" />}>
        <Text as="span" fontWeight="bold">
          {t(`${PREFIX}.callouts.hybrid_prefix`)}
        </Text>{' '}
        {t(`${PREFIX}.callouts.hybrid_text`)}
      </InfoCallout>

      <GroupStagesPreview />

      <Box>
        <Text fontSize="16px" fontWeight="semibold">
          {t(`${PREFIX}.knockout.elimination_title`)}
        </Text>
        <Text fontSize="13px" color="gray.500" mt={1} mb={3}>
          {t(`${PREFIX}.knockout.elimination_help`)}
        </Text>
        <KnockoutStageList
          addLabel={t(`${PREFIX}.actions.add_elimination_stage`)}
          isReadOnly={isReadOnly}
        />
      </Box>
    </Flex>
  );
};
